import { Liked } from "../components/Liked"

export const LikedPage = () => {
    return (
        <div>
            <Liked />
        </div>
    )
}